import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationAdminKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        webhooks_history: {
          header: 'HEADER',
          download_report_btn: 'DOWNLOAD_REPORTS',
        },
      },
    },
  }));
}
